import useDeleteAdminUser from '../../api/useDeleteAdminUser';
import { AdminButton } from '../AdminButton';
import AdminErrorMessage from '../atoms/AdminErrorMessage';
import AdminModal from '../molecules/AdminModal';
import { useState } from 'react';

type AdminUserDeleteModalProps = {
  open: boolean;
  onClose: () => void;
  userId: number | null;
  userName: string | null;
};

export default function AdminUserDeleteModal({
  open,
  onClose,
  userId,
  userName,
}: AdminUserDeleteModalProps) {
  const { mutateAsync: deleteUser, isPending } = useDeleteAdminUser();
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async () => {
    if (!userId) return;
    try {
      setError(null);
      await deleteUser({ id: userId });
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : '削除に失敗しました');
    }
  };

  return (
    <AdminModal
      open={open}
      onClose={onClose}
      title="ユーザーの削除"
      titleColor="text-[#ff4e4e]"
      maxWidth="max-w-[600px]"
      footer={
        <div className="flex items-center justify-end gap-4">
          <AdminButton label="キャンセル" variant="secondary" onClick={onClose} />
          <AdminButton
            label={isPending ? '削除中...' : '削除する'}
            variant="danger"
            disabled={isPending}
            onClick={handleDelete}
          />
        </div>
      }
    >
      <div className="py-9 text-center text-sm text-[#333]">
        {userName
          ? `本当に ${userName} を削除してもよろしいですか？`
          : '本当にこのユーザーを削除してもよろしいですか？'}
      </div>
      <AdminErrorMessage message={error} />
    </AdminModal>
  );
}
